// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CHECK CONNECTION */
.statusLoader {
    width: 28px;
    height: 28px;
}

.statusRequest {
    animation: fadeIn 1s ease-in infinite alternate;
}

.testConnection {
	max-width: 180px;
}

@keyframes fadeIn {
	from {
		opacity: 0;
	}

	to {
		opacity: 0.5;
	}
}

/* ALERTS */
.alert {
	border-radius: .25rem;
	border: 1px solid transparent;
	margin-bottom: 1rem;
	padding: .75rem 1.25rem;
	position: relative;
}

.alertDanger {
	background-color: var(--color-error-back);
	border-color: var(--color-error-border);
	color: var(--color-error-front);
}

#errorSettings {
	margin-top: 50px;
	width: 400px;
}

.success {
	color: var(--color-success);
}

.warning {
	color: var(--color-warning);
}

.error {
	color: var(--color-error-front);
}

.opaRedNote {
	color: darkred;
	font-weight: 500;
	margin: 20px 0 5px 0;
}

.opaReadMore {
	font-size: 16px;
	font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/styles/utility.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,YAAY;CACb;AACD;;AAEA,WAAW;AACX;CACC,qBAAqB;CACrB,6BAA6B;CAC7B,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,yCAAyC;CACzC,uCAAuC;CACvC,+BAA+B;AAChC;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB","sourcesContent":["/* CHECK CONNECTION */\r\n.statusLoader {\r\n    width: 28px;\r\n    height: 28px;\r\n}\r\n\r\n.statusRequest {\r\n    animation: fadeIn 1s ease-in infinite alternate;\r\n}\r\n\r\n.testConnection {\r\n\tmax-width: 180px;\r\n}\r\n\r\n@keyframes fadeIn {\r\n\tfrom {\r\n\t\topacity: 0;\r\n\t}\r\n\r\n\tto {\r\n\t\topacity: 0.5;\r\n\t}\r\n}\r\n\r\n/* ALERTS */\r\n.alert {\r\n\tborder-radius: .25rem;\r\n\tborder: 1px solid transparent;\r\n\tmargin-bottom: 1rem;\r\n\tpadding: .75rem 1.25rem;\r\n\tposition: relative;\r\n}\r\n\r\n.alertDanger {\r\n\tbackground-color: var(--color-error-back);\r\n\tborder-color: var(--color-error-border);\r\n\tcolor: var(--color-error-front);\r\n}\r\n\r\n#errorSettings {\r\n\tmargin-top: 50px;\r\n\twidth: 400px;\r\n}\r\n\r\n.success {\r\n\tcolor: var(--color-success);\r\n}\r\n\r\n.warning {\r\n\tcolor: var(--color-warning);\r\n}\r\n\r\n.error {\r\n\tcolor: var(--color-error-front);\r\n}\r\n\r\n.opaRedNote {\r\n\tcolor: darkred;\r\n\tfont-weight: 500;\r\n\tmargin: 20px 0 5px 0;\r\n}\r\n\r\n.opaReadMore {\r\n\tfont-size: 16px;\r\n\tfont-weight: 700;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
